// @flow

import type { ApprovableChangeState } from "./types";

export const onToggleBlockApprovableChangeModal = (state: ApprovableChangeState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showBlockModal: payload,
  },
});

export const onToggleDeferApprovableChangeModal = (state: ApprovableChangeState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showDeferModal: payload,
  },
});

export const onToggleApproveApprovableChangeModal = (state: ApprovableChangeState) => ({
  payload,
}: Object) => ({
  ...state,
  modals: {
    ...state.modals,
    showApproveModal: payload,
  },
});

export const onSetApprovableChangeSchemas = (state: ApprovableChangeState) => ({
  payload,
}: Object) => ({
  ...state,
  schemas: payload,
});
